<template>
  <p>
    Type a question about a process or workflow. You'll get step-by-step answers
    from SOPs.
  </p>
  <div>
    <LegacyTTextarea
      v-model="inputText"
      :disabled="loading"
      name="ai-input"
      placeholder="e.g. How do I add a playbook?"
      :rows="2"
      @keydown.enter="submitOnEnter"
    />
    <TMPrimaryButton
      class="float-right"
      :disabled="!inputText || loading"
      label="Ask"
      @click="submitQuery"
    />
  </div>
  <LlmDevTools v-if="showDevTools" v-model="devToolOptions" :loading="loading">
    <div class="mt-2">
      <LegacyTTextarea
        v-model="userContext"
        name="user-context-input"
        :rows="2"
        label="Ask Thyme Box User Context"
      />
    </div>
  </LlmDevTools>
</template>

<script lang="ts">
import TMPrimaryButton from '@thyme/nashville/src/components/button/TMPrimaryButton.vue'
import { defineComponent } from 'vue'
import LegacyTTextarea from '@/legacy/nashville/input/LegacyTTextarea.vue'
import LlmDevTools from '@/tokens/llm/LlmDevTools/LlmDevTools.vue'
import setup from './controller'
import { ASK_SOP_INPUT_PROPS } from './types'

export default defineComponent({
  components: {
    TMPrimaryButton,
    LegacyTTextarea,
    LlmDevTools,
  },
  props: ASK_SOP_INPUT_PROPS,
  emits: ['submit'],
  setup,
})
</script>
